import { cx } from '@linaria/core';
import { memo } from 'react';
import "./InlineLoading.linaria.module.css!=!./InlineLoading?./InlineLoading.linaria.module.css?css=H4sIAAAAAAAAA41V246kKhR9n6/wZZLqpK2It1Ln5fwJQUGl5KKA98y/n1RXeau2T44+yIK1tmwWbK7IcMgBBDW/ycmZa6J0TTJDO5IAx3Hq4c/fX9cHKdYQgHB0UDVjqmuGxoQKRgWxc0ZW1h2CMpT3djqiGTFaCFsTlicZEYaoRYAU7FSXkeGI5kdQG1P1mIsUiZL9okgJBE2cZcX0Bp+aXqE6EfLxWRSsgmD0fcnyNzjXCGMqCpuR3CT+lixjRwX7plC0KA+S4A6B1inF5ZxKhYmyFcK01Ung/F5XJ4WgbqTnk5lTYfcUmzJxroEifKWEB0pJvv5z5BAXUlznhT8vw8vICOOsn7rgAGYkKEePZbRxq74aCdCLBIQQuFkw1N0b3MmoIU+dnclWmISKnApqyBqjgkGb6aw/ol0EQ/lj1fJWPP0kSG/qDGr/5oXgiHZqgThJdNNSXS6igsKx9J00nzlSBRWJu1nR3qBKq144s1FI6FwqbmszMpLUimiiOmJ7eO+JEhwI9+jJ0ZIdY7Pk4MhCORvuxnX4JP7NgTyvoymaUznYukRY9oljPV9VpOgShJ8W8N1PK3Q+LfCxuT1yrCg/gDO3Xb1zqvYqkXtH9B9OPY44UjuvQHBzYmze4Ltbdcs02nZI6UHQ0Rt5bZENvuyzjawTb+dhFsGONixIj2jOpTC2phNJ3OeJ+KciY64QJ9rSNRWCKGv+Zb0e5/cOPJ51QySWkgYZcnEwKT7+rKS/aws4/0Pthaf6LWsT+6PRR7TPGRwrrBl62rG1wu5La9HA3BSUuUe0BEulMZIn0RYP+Pk4FS0EMmJ0bKzra33e63fKZFatItLqIbzB0uX8Hm6aWmr6rMSEocf1sBrVKMZbCPzRvY3tJnhu9GCbTqWxkdF34uvA7JhgwAFnNWx1R2O+Mi1Mu+cRoRMVRfIqs6nchE7WlphA0DIy5OlRuWR9SDeup/YeQm1EH0VH/poxSrVk7a7aNVV7RwZiVkVDdxQ9swb7q2Tq6zo+Jb8y37Nl00bhBEHpNcFk3lN/5Jt49WBpySi2OqQutl0oQoTN82ytC8DjfZ5Vy310FuXkcgIYxVwICOLCc1N8VK2nO1l6wdXVVtamNLNTMlGiLs41+LScT+vrCz6sb7dEG6ohHSBwJS6K7qzvdKqZZFIl78k+D2ONFBHmp/b6ZzeM3eoO01xx4Z90Hf6bCFPaMrfNWJML+NgXVPLYQLZz9YO1ouLGOEEE075R4/17z8+R3dPI3ho4KsZGtBAUzb334pOun0N7p6HB16T/BThxdsfyCQAA"
const dotLoadingStyles = "atm_m1_1pm7oz0 atm_9s_116y0ak atm_j_1h6ojuz atm_ar_vrvcex atm_be_1q9ccgz atm_lk_1y44olf atm_ll_1y44olf";
const dotStyles = "atm_5j_1ssbidh atm_jb_1pqo34e atm_j6_1pqo34e atm_e2_idpfg4 atm_y_9cwzv5 atm_16_12c5xpv atm_1k_5ucscw atm_1c_s47361 atm_gi_yh40bf atm_u7_rbkwn0";
const firstDot = {
  animationDelay: '0s'
};
const secondDot = {
  animationDelay: '.33s'
};
const thirdDot = {
  animationDelay: '.66s'
};
interface InlineDotLoadingProps {
  className?: string;
  active?: boolean;
}
export const InlineDotLoading = memo((props: InlineDotLoadingProps) => {
  const {
    className,
    active = false
  } = props;
  if (!active) return null;
  return <div className={cx(dotLoadingStyles, className)}>
            <span style={firstDot} className={dotStyles} />
            <span style={secondDot} className={dotStyles} />
            <span style={thirdDot} className={dotStyles} />
        </div>;
});
const pulseLoadingStyles = "atm_9s_116y0ak atm_j_1h6ojuz atm_ar_vrvcex atm_be_1q9ccgz atm_lk_1y44olf atm_ll_1y44olf";
const pulseDotStyles = "atm_5j_1ssbidh atm_jb_1rnm1n2 atm_j6_1rnm1n2 atm_e2_1rnm1n2 atm_vy_1rnm1n2 atm_70_mfp8z8 atm_y_ymdrim atm_16_12c5xpv atm_1k_p3knf3 atm_1c_15709dt atm_gi_yh40bf";
const drawerPulseStyles = "atm_h3_1vi7ecw atm_c8_viql5b";
interface InlinePulseLoadingProps {
  active?: boolean;
  drawer?: boolean;
}
export const InlinePulseLoading = memo((props: InlinePulseLoadingProps) => {
  const {
    active = false,
    drawer = false
  } = props;
  if (!active) return null;
  return <div className={cx(pulseLoadingStyles, drawer && drawerPulseStyles)}>
            <span className={pulseDotStyles} />
        </div>;
});
const circularLoadingStyles = "atm_h3_t94yts atm_9s_1txwivl atm_gq_ftgil2 atm_14fyzgu_1o8liyq atm_1eusx67_h2mmj6 atm_cqrlmu_14y27yu atm_ksdto8_14y27yu atm_1xd5mlp_usvi9m atm_10cuhde_1ulexfb atm_9pzuj6_stnw88 atm_1qkujat_dlk8xv atm_lzwpp9_dlk8xv atm_oqu86z_1h3q5zt atm_13mwfck_1ssbidh atm_1da9mnn_19g32bd atm_1u6rxbx_12odggv atm_12692kj_bfrmn4 atm_dqt058_bwqryj atm_8gyqnu_1gqjw39";

/**
 * Alternative to MUI's CircularLoading
 */
export const InlineCircularLoading = memo(({
  styleOverrides
}: {
  styleOverrides?: string;
}) => {
  return <div data-testid="InlineCircularLoading__Spinner" className={cx(circularLoadingStyles, styleOverrides)}>
                <div className={'spinner'}>
                    <div></div>
                    <div></div>
                    <div></div>
                    <div></div>
                </div>
            </div>;
});